import { Component, OnInit, inject } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { Doctor, PatientDoctor, SelectOption } from '@xmedical/core';
import { XmedicalUiModule } from '@xmedical/ui';

// Pure dialog content — collects edits to an existing doctor and returns
// the merged value via dialogRef.close(). The opener
// (PatientDoctorsFieldsetComponent) decides what to do with it (patch the
// form, persist via [doctorEditPersist] when the doctor has a real id).
@Component({
  selector: 'xcs-doctor-edit-card',
  templateUrl: './doctor-edit-card.component.html',
  styleUrl: './doctor-edit-card.component.scss',
  imports: [
    ReactiveFormsModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    XmedicalUiModule,
  ],
})
export class DoctorEditCardComponent implements OnInit {

  private dialogRef = inject<MatDialogRef<DoctorEditCardComponent>>(MatDialogRef);
  private formBuilder = inject(UntypedFormBuilder);
  private doctor = inject<Doctor | PatientDoctor>(MAT_DIALOG_DATA);

  validate = false;
  form: UntypedFormGroup | null = null;

  contactMethodOptions: SelectOption[] = [
    { value: 'Phone', text: 'Phone' },
    { value: 'Email', text: 'Email' },
    { value: 'Fax', text: 'Fax' },
  ];

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      name: [this.doctor?.name || '', Validators.required],
      practiceNumber: [this.doctor?.practiceNumber || ''],
      tel: [this.doctor?.tel || ''],
      fax: [this.doctor?.fax || ''],
      email: [this.doctor?.email || ''],
      preferredGreeting: [this.doctor?.preferredGreeting || ''],
      preferredContactMethod: [this.doctor?.preferredContactMethod || ''],
    });
  }

  save(): void {
    if (!this.form) return;
    if (this.form.valid) {
      // Merge with the original (preserves id when present) so the opener
      // can detect "this is a real persisted doctor" via `'id' in updated`.
      this.dialogRef.close({ ...this.doctor, ...this.form.value });
      return;
    }
    this.validate = true;
  }

  close(): void {
    this.dialogRef.close();
  }
}
